import React from 'react';
import { observer } from 'mobx-react';

import { UiNavLink } from 'shared/uikit';
import { ROUTES } from 'shared/constants';

import { VmNotificationContentPropsType } from '../../types/VmNotificationContentPropsType';

type PropsType = VmNotificationContentPropsType;

export const VmNotificationArticleCreated = observer(({ notification, onClose }: PropsType) => {
    return (
        <div className={'vm-notification__content'}>
            <div className={'vm-notification__name'}>Новая статья</div>
            <div className={'vm-notification__description'}>
                В библиотеку знаний добавлена новая статья <UiNavLink to={ROUTES.ARTICLE(notification.data.article.id)} onClick={onClose}>{notification.data.article.name}</UiNavLink>
            </div>
        </div>
    );
})
